import formartOnlyNumber from './formartOnlyNumber';

const formatFederalTaxNumber = (federalTaxNumber) => {
  if (!federalTaxNumber) {
    return '';
  }

  const onlyNumber = formartOnlyNumber(federalTaxNumber);

  if (onlyNumber.length === 11) {
    return onlyNumber.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
  }

  return onlyNumber.replace(
    /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
    '$1.$2.$3/$4-$5'
  );
};

export default formatFederalTaxNumber;
